import React, { Component } from 'react'
import styled from 'styled-components'
import Modal from 'components/Modal'
import Button from 'components/Button'
import PrimaryButton from 'components/PrimaryButton'
import Input from 'components/Input'
import House from './house.component.svg'
import { PAGE_URL, isEnterprise } from 'config'

import AuthWrapper from 'containers/AuthWrapper'

const SavedModal = ({ onClose, manageProfiles, showChangeName, saved }) => (
  <SmallModal custom onClick={onClose}>
    <Wrapper>
      <House />
      <Info>
        <Title>Perfil guardado</Title>
        <Text>O perfil de simulaçao foi guardado com sucesso com o nome <strong>“{saved.name}”</strong></Text>
      </Info>
    </Wrapper>
    <ButtonWrapper>
      <Button text={`Gerir Perfis`} onClick={() => manageProfiles()} />
      <PrimaryButton text={`Alterar nome`} onClick={() => showChangeName()} />
    </ButtonWrapper>
  </SmallModal>
)

const UpdateModal = ({ onClose, profiles, state, toggleProfiles, updateProfile, saveProfile }) => (
  <SmallModal custom onClick={onClose}>
    <Wrapper>
      <House />
      <Info>
        <Title>Atualizar / guardar perfil</Title>
        <Text>Já tem perfis de simulação guardados. Pretende atualizar um perfil existente ou guardar um novo perfil?</Text>
      </Info>
    </Wrapper>
    <ButtonWrapper>
      <PrimaryButton
        text={`Guardar novo`}
        onClick={() => saveProfile(true)}
      />
      <UpdateWrapper>
        <Button text={`Atualizar`} onClick={() => toggleProfiles()} />
        {state.showingProfiles &&
        <ProfileList>
            {profiles && profiles.map(({ id, name }) => (
              <Item
                key={`profile${id}`}
                onClick={() => updateProfile(id)}
              >
                {name}
              </Item>
            ))}
        </ProfileList>
        }
      </UpdateWrapper>

    </ButtonWrapper>
  </SmallModal>
)

const UpdatedModal = ({ onClose, saved, manageProfiles }) => (
  <SmallModal custom onClick={onClose}>
    <Wrapper>
      <House />
      <Info>
        <Title>Perfil atualizado</Title>
        <Text>O perfil de simulação <strong>“{saved.name}”</strong> foi atualizado com sucesso</Text>
      </Info>
    </Wrapper>
    <ButtonWrapper>
      <Button text={`Fechar`} onClick={() => onClose()} />
    </ButtonWrapper>
  </SmallModal>
)

const ChangeNameModal = ({ onClose, updateProfile, state, changeName }) => (
  <SmallModal custom onClick={onClose}>
    <Wrapper>
      <House />
      <Info>
        <Title>Alterar nome do perfil</Title>
        <Input value={state.name} onChange={(value) => changeName(value)} />
      </Info>
    </Wrapper>
    <ButtonWrapper>
      <Button text={`Cancelar`} onClick={() => onClose()} />
      <Button text={`Guardar`} onClick={() => updateProfile(state.id, state.name)} />
    </ButtonWrapper>
  </SmallModal>
)

const LoginModal = ({ onClose, showLogin, showRegister }) => (
  <SmallModal custom onClick={onClose}>
    <Wrapper>
      <House />
      <Info>
        <Title>Para utilizar esta funcionalidade precisa de ter conta no portal Poupa Energia</Title>
      </Info>
    </Wrapper>
    <ButtonWrapper>
      <Button text={`Registar`} onClick={showRegister} />
      <PrimaryButton text={`Entrar`} onClick={showLogin} />
    </ButtonWrapper>
  </SmallModal>
)

const LoginWrapper = ({ onClose, toggler, setWidth, state, getCurrentUser, isRegister }) => (
  <ModalNoPadding custom onClick={onClose} width={state.widthLoginModal}>
    <Wrapper>
      <AuthWrapper
        setWidth={setWidth}
        getCurrentUser={getCurrentUser}
        isRegister={isRegister}
        toggler={toggler}
      />
    </Wrapper>
  </ModalNoPadding>
)

export default class SaveProfileModal extends Component {
  state = {
    name: '',
    showingProfiles: false,
    showingLogin: false,
    showingRegister: false
  }

  componentWillReceiveProps (props) {
    const { saved } = props

    if (saved && saved.name) {
      this.setState({ name: saved.name, id: saved.id })
    }
  }

  showChangeName () {
    const { toogler } = this.props
    toogler({ type: 'change' })
  }

  toggleProfiles () {
    this.setState({ showingProfiles: !this.state.showingProfiles })
  }

  manageProfiles () {
    const { settings } = this.props

    if (settings.iframed && window.top) {
      window.top.postMessage('goToProfiles', '*')
      return
    }

    const url = `${PAGE_URL}/area-reservada/#/simuladores/?tipo=${isEnterprise ? 'e' : 'r'}`
    window.location.href = url
  }

  render () {
    const { type, getCurrentUser } = this.props

    const modalProps = {
      ...this.props,
      showChangeName: this.showChangeName.bind(this),
      toggleProfiles: this.toggleProfiles.bind(this),
      manageProfiles: this.manageProfiles.bind(this),
      state: this.state,
      changeName: (name) => this.setState({ name }),
      showLogin: () => this.setState({ showingLogin: true }),
      showRegister: () => this.setState({ showingRegister: true }),
      setWidth: (width) => this.setState({ widthLoginModal: width }),
      getCurrentUser: () => {
        this.props.onClose()
        getCurrentUser({ from: 'iframe' })
      },
      toggler: this.props.toogler
    }

    if (this.state.showingLogin) {
      return <LoginWrapper {...modalProps} />
    }

    if (this.state.showingRegister) {
      return <LoginWrapper {...modalProps} isRegister />
    }

    switch (type) {
      case 'saved':
        return <SavedModal {...modalProps} />
      case 'update':
        return <UpdateModal {...modalProps} />
      case 'updated':
        return <UpdatedModal {...modalProps} />
      case 'change':
        return <ChangeNameModal {...modalProps} />
      case 'notlogged':
        return <LoginModal {...modalProps} />
      default:
        break
    }
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding: 32px;
  align-items: center;
`

const SmallModal = styled(Modal)`
  > div:last-child > div {
    max-width: 550px;
    min-width: 550px;
    transform: translateX(-50%);
    left: 50%;
  }

  .show {
    > div {
      @media screen and (max-width: 468px) {
        width: 100%;
        min-width: initial!important;
        transform: none;
        left:0;
      }
    }
  }
`

const ButtonWrapper = styled.div`
  background-color: #EFEFEF;
  box-shadow: inset 0 1px 0 0 #DEDEDE;
  padding: 12px;
  display: flex;
  flex-direction: row-reverse;
  justify-content: end;

  > * {
    width: 180px;
    margin-left: 12px;
  }
`

const Info = styled.div`
  margin-left: 20px;
`

const Title = styled.span`
  display: block;
  color: #010101;
  font-family: Nunito;
  font-size: 16px;
  font-weight: bold;
  line-height: 28px;
`

const Text = styled.span`
  color: #010101;
  font-family: Nunito;
  font-size: 16px;
  line-height: 24px;
`

const ProfileList = styled.div`
  position: absolute;
  background: #fff;
  border: 1px solid #93C13E;
  border-top: 0;
  width: 100%;
`
const Item = styled.div`
  padding: 12px;
  color: #3E3E3E;
  font-family: Nunito;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  text-shadow: 0 1px 0 0 #FFFFFF;
  cursor: pointer;

  &:hover {
    background-color: #EFEFEF;
  }
`

const UpdateWrapper = styled.div`
  position: relative;
`
const ModalNoPadding = styled(Modal)`
  div:last-child > div > div > div {
    padding: 0;
  }

  .show > div:nth-child(1) {
    width: 680px;
    left: 50%;
    min-width: 680px;
    transform: translateX(-50%);

    @media screen and (max-width: 468px) {
      width: 100%;
      min-width: initial!important;
      transform: none;
      left:0;
    }
  }

  .show {
    overflow: auto;
    height: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/containers/SaveProfileModal/index.js